/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioSalesforceIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-salesforce-prod" */ './utils').then(
			(m) => m.ForgePioSalesforceIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/icon' },
);

const LazyForgePioSalesforceSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-salesforce-prod-search-result" */ './utils').then(
			(m) => m.ForgePioSalesforceSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioSalesforceIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioSalesforceIconComponent />
	</Suspense>
);

export const ForgePioSalesforceSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioSalesforceSearchResultIconComponent />
	</Suspense>
);
